import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";


export default class ClientConfigURLRequest implements IRequestBuilder {
    get method() {
      return "GET";
    }
  
    get path() {
      // ConsoleUtil.green(`${location.protocol}//${location.host}/casino/cdnconfig.json`)
      return `${location.protocol}//${location.host}/casino/cdnconfig.json`
    }
  
    get requestData() {
      let requestParams = {};
      return requestParams;
    }
  }